import React from "react";
import {createRoot} from 'react-dom/client';

import Contact from "./contact";

const container = document.getElementById("contactApp");
const root = createRoot(container);
root.render(
	<React.StrictMode>
		<Contact {...container.dataset} />
	</React.StrictMode>
);
